import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextField from "UI/Form/TextField";
import Button from "UI/Button";

import validate from './validation.js';
import Logo from "Components/Logo";
import Form from "Components/Form/Form";
import {Link} from "react-router-dom";

export default class LoginForm extends React.Component
{
    state = {
        busy: false,
        failed: false
    };

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    };

    submit = data => {
        this.props.onSubmit(data.email, data.password, data.remember).catch(error => {
            console.log(error);
            this.setState({busy: false, failed: true});
        });
    };

    render()
    {
        const defaultValues = {
            remember: true
        };

        return <div className="w-full max-w-sm">
            <Logo className="h-12 text-white mb-4 m-auto" />

            <Form defaults={defaultValues} validate={validate} onSubmit={this.submit}>
                {
                    (data, onChange, validation) => <fieldset disabled={this.state.busy} className="bg-white shadow-md rounded px-8 pt-10 pb-8 mb-4 space-y-4 prose">

                        <h1>Log in to your account</h1>

                        <TextField
                            id="email"
                            label="Email"
                            placeholder="e.g. mickey@acme.org"
                            value={data.email || ''}
                            onChange={onChange('email')}
                            error={validation.hasErrors('email')}
                            type='email'
                            help={validation.getErrors('email')}
                        />

                        <TextField
                            id="password"
                            label="Password"
                            type='password'
                            value={data.password || ''}
                            onChange={onChange('password')}
                            error={validation.hasErrors('password')}
                            help={validation.getErrors('password')}
                        />

                        <div className="flex items-center">

                            <input
                                id='remember'
                                type="checkbox"
                                onChange={() => onChange('remember', ! data.remember)}
                                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                checked={!! data.remember}
                            />

                            <label htmlFor='remember' className="w-full ml-2 block cursor-pointer text-gray-700 text-sm font-medium">
                                Remember me
                            </label>
                        </div>

                        {
                            this.state.failed &&
                                <div className="flex items-center justify-between mt-4 text-sm text-red-600">
                                    Login failed. Please check your details and try again.
                                </div>
                        }

                        <div className="flex items-center justify-between pt-4">
                            {/*<a className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800" href="#">Forgot Password?</a>*/}
                            <Button type='primary' busy={this.state.busy}>Sign In</Button>
                        </div>

                    </fieldset>
                }
            </Form>

            <div className='text-center text-white'>
                Don't have an account? <Link to='/signup' className='underline'>Sign up now</Link>.
            </div>

        </div>;
    }
}
